import { c as _c } from "react/compiler-runtime";
import type { Account, RestoreAccount, SourceAccount } from '@repo/api-gw-sdk';
import { type ReactNode, useMemo } from 'react';
import { CloudProviders } from '@/assets/logos/cloudProviders';
import type { MultiSelectConditionComponentProps } from '@/types/advanceFilter';
import { getAccountProvider } from '@/utils/accounts';
import { MultiSelectConditionPanel } from '../conditions/conditionComponents';
import { CircleImage } from '../shared/circleImage';
export const AccountCondition = props => {
  const $ = _c(13);
  const matchesName = props.matchOn === "name";
  const accounts = props.accounts;
  let grouped;
  if ($[0] !== accounts || $[1] !== matchesName) {
    grouped = new Map();
    for (const account of accounts ?? []) {
      const matched = matchesName ? account.name : account.providerAccountId;
      const other = matchesName ? account.providerAccountId : account.name;
      const group = grouped.get(matched);
      if (group) {
        group.others.add(other);
        continue;
      }
      const provider = CloudProviders[getAccountProvider(account)];
      grouped.set(matched, {
        others: new Set([other]),
        logo: provider && <CircleImage alt={provider.displayName} src={provider.logo} className="my-[16px]" />
      });
    }
    $[0] = accounts;
    $[1] = matchesName;
    $[2] = grouped;
  } else {
    grouped = $[2];
  }
  let t0;
  if ($[3] !== grouped) {
    t0 = Array.from(grouped, _temp);
    $[3] = grouped;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const options = t0;
  const t1 = props.isLoading ?? false;
  let t2;
  if ($[5] !== props.entityName || $[6] !== props.property) {
    t2 = props.entityName || props.property.displayName.toLowerCase();
    $[5] = props.entityName;
    $[6] = props.property;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== options || $[9] !== props || $[10] !== t1 || $[11] !== t2) {
    t3 = <MultiSelectConditionPanel showAddNewButton={true} showSearchBox={true} isLoading={t1} entityName={t2} shouldShowId={true} options={options} {...props} />;
    $[8] = options;
    $[9] = props;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};
function _temp(t0) {
  const [matched_0, t1] = t0;
  const {
    others,
    logo
  } = t1;
  return {
    id: matched_0,
    name: Array.from(others).join(", "),
    Image: logo
  };
}